<label class="control-label" :for="props.id">{{ props.inputLabel }}<span class="control-label__required" v-if="props.isRequired">*</span></label>